module.exports = __webpack_public_path__ + "media/images/workplace/banners/uhrs_job_banner_variant2_image-90d03e952ca2274fb49682a394125928.jpg";